import { Star, ShieldCheck, Clock } from "lucide-react";
import { SITE } from "../lib/site";

export default function TopBanner() {
  return (
    <div className="bg-[#2B2118] text-[#E8DCC9] text-xs" data-testid="top-banner">
      <div className="container-x py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-4 flex-wrap">
          <span className="inline-flex items-center gap-1.5">
            <Star className="w-3 h-3 fill-[#FFB100] text-[#FFB100]" />
            <strong className="text-white">5,0 / 5</strong> sur Google
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-[#E8DCC9]/80">
            <ShieldCheck className="w-3 h-3" /> {SITE.guaranteeShort}
          </span>
          <span className="hidden md:inline-flex items-center gap-1.5 text-[#E8DCC9]/80">
            <Clock className="w-3 h-3" /> Devis sous 48 h
          </span>
        </div>
        <div className="hidden lg:flex items-center gap-2 text-[#E8DCC9]/70">
          <span>Bordeaux Métropole · Gironde · Bassin d'Arcachon</span>
        </div>
      </div>
    </div>
  );
}
